module.exports = __webpack_public_path__ + "img/gpay-icon.85237616.png";